import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ActionComponent from '../../../components/ActionComponent'
import { getMapStateToProps, getPropTypes, getSandreList } from '../../../utils/StoreUtils'
import StationMapDashboardPanel from '../../../station/components/dashboard/component/map/StationMapDashboardPanel'
import Input from '../../../components/forms/Input'
import DatePicker from '../../../components/forms/DatePicker'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import Textarea from '../../../components/forms/Textarea'
import Checkbox from '../../../components/forms/Checkbox'
import { SANDRE } from '../../../referencial/constants/ReferencialConstants'
import { hasValue } from '../../../utils/NumberUtil'
import LastEventPanel from '../../../station/components/event/LastEventPanel'
import ContactCard from '../../../referencial/components/contact/components/ContactCard'
import StationUpdatePanel from '../../../station/components/update/StationUpdatePanel'
import { maxBy, some } from 'lodash'
import { getControlColor } from '../../../utils/InstallationUtils'
import { getColorCircleElement, getRGBColor } from '../../../utils/ColorUtil'
import AlertPanel from '../../../components/alert/AlertPanel'
import moment from 'moment'
import { getDate } from '../../../utils/DateUtil'
import InstallationArrangementsTable from './arrangements/InstallationArrangementsTable'
import LinkedStationsPanel from '../../../station/components/associatedStation/LinkedStationsPanel'
import DtoInstallationType from '../../dto/installation/DtoInstallationType'
import CaptureDownstreamDistribUnitPanel from '../capture/components/CaptureDownstreamDistribUnitPanel'
import DistributionUnitAction from '../../../distributionUnit/actions/DistributionUnitAction'
import InstallationAction from '../../../installation/actions/InstallationAction'
import MaterielAssigned from '../../../station/components/materiel/MaterielAssigned'
import InstallationInfosDashboard from '../installations/components/InstallationInfosDashboard'
import UnitChartPanel from '../../../productionUnit/components/UnitChartPanel'
import { getStatuses } from '../../../utils/QualityUtils'
import { H_DISTRIBUTION_MODULE, H_MAT_MODULE } from '../../../account/constants/AccessRulesConstants'
import HabilitationRequired from '../../../utils/components/HabilitationRequired'
import InstallationCounterPanel from './InstallationCounterPanel'
import { INSTALLATION_TYPE } from 'installation/constants/InstallationConstants'
import LiftingLinkedProduction from '../liftingStation/LiftingLinkedProduction'
import { Card, CardContent, Grid } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'

const storeProps = {
    installation: false,
    cities: false,
    watersheds: false,
    users: false,
    sandreCodes: false,
    contributors: false,
    installationEvents: false,
}

class InstallationDashboardPanel extends ActionComponent {
    state = {
        uncheckedStations: [],
    }
    componentDidMount() {
        if (!this.props.captureDownstreamDistribUnits.length) {
            this.props.fetchCaptureDownstreamDistribUnits()
        }

        if (!this.props.installationsTypes.length) {
            this.props.fetchInstallationTypes()
        }

        if (!this.props.distributionUnits.length) {
            this.props.fetchDistributionUnits()
        }
    }

    getCartographyData = (installation) => {
        return installation?.link_geo?.length ? installation.link_geo[0] : {}
    }

    getOriginIcon = (installation) => {
        return hasValue(installation.jobExecutionId) ? (
            <h6 className='valign-wrapper'>
                <i className='material-icons rem-3-size padding-right-1'>wifi</i>
                {i18n.automaticUpdate}
            </h6>
        ) : null
    }

    getOriginStatusColor = (installation) => {
        if (hasValue(installation.status)) {
            const color = getControlColor(installation.status)
            return getColorCircleElement(getRGBColor(color), true)
        }
        return null
    }

    getDiagnosticAlertPanel = () => {
        const diagnosticEvents = this.props.installationEvents.filter(i => i.diagnostic && i.diagnosticDeadline)
        if (diagnosticEvents.length) {
            const lastDate = maxBy(diagnosticEvents, 'diagnosticDeadline').diagnosticDeadline
            if (moment().isSameOrAfter(moment(lastDate).year(moment(lastDate).year() - 2))) {
                const color = moment().isSameOrAfter(moment(lastDate).year(moment(lastDate).year() - 1)) ? 'red' : 'orange'
                return (
                    <AlertPanel comment={i18n.diagnosticDeadlineOn + getDate(lastDate)}
                        title={i18n.diagnosticToPlan}
                        icon={'warning'} color={color}
                    />
                )
            }
        }
        return null
    }

    hasType = (type) => this.props.associatedSites.filter(ass => ass.stationLinkedType === type).length

    render() {
        const { installation } = this.props
        const readMode = { readMode: true, editMode: false, hideNull: true }

        const cartographyData = this.getCartographyData(installation)

        return (
            <Grid container sx={{ margin: '10px 0 60px 0' }} spacing={1} alignItems={'flex-start'}>
                <Grid container size={9}>
                    <Grid size={12}>
                        <InstallationInfosDashboard />
                    </Grid>
                    {some(['exploitationCode', 'comments'], key => hasValue(installation[key])) && (
                        <Grid size={12}>
                            <Card>
                                <CardTitle title={i18n.characteristics} />
                                <CardContent>
                                    <Grid container size={12}>
                                        <Grid size={6}>
                                            <Checkbox componentClassName='padding-bottom-1' col={12} checked={hasValue(installation.exploitationCode) ? installation.exploitationCode == 1 : null}
                                                label={i18n.exploitation} disabled {...readMode}
                                            />
                                        </Grid>
                                        <Grid size={6}>
                                            <Textarea col={12} value={installation.comments} title={i18n.comment} {...readMode} />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    )}
                    <UnitChartPanel unit={this.props.installation} uncheckedStations={this.state.uncheckedStations} setDataLoaded={this.props.setDataLoaded} fromStationType='INST' />
                    <Grid size={12}>
                        <InstallationCounterPanel
                            stationId={installation.id}
                            showTitle
                            showKeyFigures
                            inPopup
                        />
                    </Grid>
                    <InstallationArrangementsTable summarized />
                    <HabilitationRequired habilitation={H_DISTRIBUTION_MODULE}>
                        <Grid size={12}>
                            <Card>
                                <CardTitle title={i18n.distributionUnit}/>
                                <CardContent>
                                    <CaptureDownstreamDistribUnitPanel station={installation} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </HabilitationRequired>

                    {installation.installationType === INSTALLATION_TYPE.CAPTURE && <LiftingLinkedProduction /> || null}
                </Grid>
                <Grid container size={3}>
                    <Grid container marginRight={1}>
                        <Grid size={12}>
                            <StationUpdatePanel station={installation} />
                        </Grid>
                        {this.getDiagnosticAlertPanel()}
                        {some(['dataOrigin', 'closeComment', 'status', 'statusDate', 'deliberationDate', 'confidential'], key => hasValue(installation[key])) && (
                            <Grid size={12}>
                                <Card>
                                    <CardContent>
                                        {this.getOriginIcon(installation)}
                                        <Grid size={12}>
                                            <Input title={i18n.dataOrigin} value={installation.dataOrigin} {...readMode} />
                                        </Grid>
                                        <Grid size={12}>
                                            <Select label={[this.getOriginStatusColor(installation), i18n.status]} value={installation.status}
                                                options={getStatuses()} {...readMode}
                                            />
                                        </Grid>
                                        <Grid size={12}>
                                            <DatePicker value={installation.statusDate} id='statusDate' title={i18n.controlDoneAt} {...readMode} />
                                        </Grid>
                                        <Grid size={12}>
                                            <Select label={i18n.controlDoneBy} value={installation.statusLogin}
                                                options={this.props.users.map(u => ({ code: u.login, name: u.name || u.login }))} {...readMode}
                                            />
                                        </Grid>
                                        <Grid size={12}>
                                            <DatePicker value={installation.endDate} id='deliberationDate' title={i18n.deliberationDate} {...readMode} />
                                        </Grid>
                                        <Grid size={12}>
                                            <Input value={installation.closeComment} title={i18n.become} {...readMode} />
                                        </Grid>
                                        <Grid size={12}>
                                            <Checkbox label={i18n.confidential} {...readMode}
                                                checked={hasValue(installation.confidential) ? installation.confidential == '1' : null} disabled
                                            />
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )}
                        <ContactCard
                            title={i18n.contact}
                            contactCode={installation.ownerCode}
                            {...readMode}
                        />
                        {some(['address', 'x', 'y', 'altitude', 'parcel', 'section', 'ignMap', 'geologicalMap'], key => hasValue(installation[key])) && (
                            <Grid size={12}>
                                <Card>
                                    <CardContent>
                                        <Grid size={12}>
                                            <Input title={i18n.address} value={installation.address} {...readMode} />
                                        </Grid>
                                        <Grid size={12}>
                                            <Select value={installation.townCode} label={i18n.city} options={this.props.cities} keyValue='id' displayWithCode {...readMode} />
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={6}>
                                                <NumberField title='X' value={installation.x} floatValue {...readMode} />
                                            </Grid>
                                            <Grid size={6}>
                                                <NumberField title='Y' value={installation.y} floatValue {...readMode} />
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={6}>
                                                <NumberField title='Z' value={installation.altitude} floatValue {...readMode} />
                                            </Grid>
                                            <Grid size={6}>
                                                <Select label={i18n.projection} value={installation.projection}
                                                    options={getSandreList(this.props.sandreCodes, SANDRE.PROJECTION)} {...readMode}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={6}>
                                                <Input title={i18n.section} value={cartographyData.parcel} {...readMode} />
                                            </Grid>
                                            <Grid size={6}>
                                                <Input title={i18n.parcel} value={cartographyData.section} {...readMode} />
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={6}>
                                                <Input title={i18n.ignMap} value={cartographyData.ignMap} {...readMode} />
                                            </Grid>
                                            <Grid size={6}>
                                                <Input title={i18n.geologicalMap} value={cartographyData.geologicalMap} {...readMode} />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )}
                        <Grid size={12}>
                            <HabilitationRequired habilitation={H_MAT_MODULE}>
                                <MaterielAssigned stationId={this.props.installation.id} type={this.props.stationType} />
                            </HabilitationRequired>
                        </Grid>
                        <Grid size={12}>
                            <LastEventPanel id={this.props.installation.id} events={this.props.installationEvents} stationId={this.props.installation.id}
                                stationType='installation'
                            />
                        </Grid>
                        <Grid size={12}>
                            <StationMapDashboardPanel noMarkerTooltip station={installation} type={'installation'} />
                        </Grid>
                        <Grid size={12}>
                            <LinkedStationsPanel
                                onReMount={this.props.onReMount}
                                dashboardMode
                                checkable
                                changeUncheckedStations={tab => this.setState({ uncheckedStations: tab })}
                                station={this.props.installation}
                                withColors
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

InstallationDashboardPanel.propTypes = getPropTypes(storeProps, {
    setDataLoaded: PropTypes.func,
    onRemount: PropTypes.func,
    stationType: PropTypes.string,
    installationsTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallationType)),
})

const mapStateToProps = (store) => getMapStateToProps(storeProps, {
    installationsTypes: store.InstallationReducer.installationsTypes,
    captureDownstreamDistribUnits: store.DistributionUnitReducer.captureDownstreamDistribUnits,
    associatedSites: store.StationReducer.associatedSites,
    distributionUnits: store.DistributionUnitReducer.distributionUnits,
})

const mapDispatchToProps = {
    fetchCaptureDownstreamDistribUnits: DistributionUnitAction.fetchCaptureDownstreamDistribUnits,
    fetchInstallationTypes: InstallationAction.fetchInstallationTypes,
    fetchDistributionUnits: DistributionUnitAction.fetchDistributionUnits,
}

export default connect(mapStateToProps, mapDispatchToProps)(InstallationDashboardPanel)